import { render, staticRenderFns } from "./ChartCompo.vue?vue&type=template&id=1ea1ce3b&scoped=true&"
import script from "./ChartCompo.vue?vue&type=script&lang=js&"
export * from "./ChartCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1ce3b",
  null
  
)

export default component.exports